import {Component, Inject} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSelectModule} from "@angular/material/select";
import {MatOptionModule} from "@angular/material/core";
import {NgIf} from "@angular/common";
import {PatientHealthEvent} from "@core/models/PatientHealthEvent";

export interface HEdata {
  data: PatientHealthEvent
}

@Component({
  selector: 'app-patient-health-event-description',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatDatepickerModule,
    MatSelectModule,
    MatOptionModule,
    NgIf,
  ],
  templateUrl: './patient-health-event-description.component.html',
  styleUrl: './patient-health-event-description.component.scss'
})
export class PatientHealthEventDescriptionComponent {
  dialogTitle: string = '';
  detalles: PatientHealthEvent;

  constructor(
    public dialogRef: MatDialogRef<PatientHealthEventDescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HEdata,
  ) {
    this.detalles = data.data;
  }
}
